import React, { useState } from "react";
import { Navigate, Routes, Route, useLocation } from "react-router-dom";
import SignIn from "./Components/SignIn";
import AdminSignIn from "./Components/AdminSignIn";
import Template from "./Components/Template";
import TemplateTable from "./Components/TemplateTable";
import Fillers from "./Components/Fillers";
import UploadCard from "./Components/UploadCard";
import Status from "./Components/Status";
import SignUp from "./Components/SignUp";
import OTP from "./Components/OTP";
import ForgotPassword from "./Components/ForgotPassword";
import AdminForgotPassword from "./Components/AdminForgotPassword";
// import Dashboard from "./Components/Dashboard"; // keeping for reference if needed
import CardData from "./Components/CardData";
import Subscription from "./Components/Subscription";
import Profile from "./Components/Profile";
import AdminUsers from "./Components/AdminUsers";
import AdminDashboard from "./Components/AdminDashboard";
import AdminPayments from "./Components/AdminPayments";
import AdminPlans from "./Components/AdminPlans";
import AdminLogs from "./Components/AdminLogs";
import AdminLayout from "./layouts/AdminLayout";
import UserLayout from "./layouts/UserLayout";
import AdminProtectedRoute from "./routes/AdminProtectedRoute";
import UserProtectedRoute from "./routes/UserProtectedRoute";

export const startUrl = `/`;

function App() {
  const location = useLocation(); // Re-render App dynamically on route change
  
  let authObj = null;
  try {
    const authStr = localStorage.getItem("auth");
    if (authStr && authStr !== "true") {
      authObj = JSON.parse(authStr);
    } else if (authStr === "true") {
      authObj = { role: "user" }; // default to user for legacy fallback
    }
  } catch(e) {}
  
  const auth = !!authObj;
  const role = authObj ? authObj.role : null;

  const [successOpen, setsuccessOpen] = useState(false);
  const [successMessage, setsuccessMessage] = useState("");
  const [successStatus, setsuccessStatus] = useState(false);
  const [successColor, setsuccessColor] = useState(false);

  return (
    <Routes>
      {/* Unprotected Auth Routes */}
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
      <Route 
        path="/sign-up" 
        element={
          !auth ? <SignUp /> : <Navigate to={role === 'admin' ? "/admin" : "/"} replace />
        } 
      />
      
      {/* User Login Route */}
      <Route 
        path="/login" 
        element={
          !auth ? (
            <SignIn
              setsuccessOpen={setsuccessOpen}
              setsuccessMessage={setsuccessMessage}
              setsuccessStatus={setsuccessStatus}
              setsuccessColor={setsuccessColor}
            />
          ) : (
            <Navigate to={role === 'admin' ? "/admin" : "/"} replace />
          )
        } 
      />

      {/* Admin Login Route */}
      <Route 
        path="/admin/login" 
        element={
          !auth ? (
            <AdminSignIn
              setsuccessOpen={setsuccessOpen}
              setsuccessMessage={setsuccessMessage}
              setsuccessStatus={setsuccessStatus}
              setsuccessColor={setsuccessColor}
            />
          ) : (
            <Navigate to={role === 'admin' ? "/admin" : "/"} replace />
          )
        } 
      />



      {/* User Protected Routes */}
      <Route element={<UserProtectedRoute />}>
        <Route 
          path="/" 
          element={
            <UserLayout
              successOpen={successOpen}
              setsuccessOpen={setsuccessOpen}
              successMessage={successMessage}
              setsuccessMessage={setsuccessMessage}
              successStatus={successStatus}
              setsuccessStatus={setsuccessStatus}
              successColor={successColor}
              setsuccessColor={setsuccessColor}
            />
          }
        >
          {/* User uses root routes without /admin */}
          <Route index element={<TemplateTable />} />
          <Route path="template" element={<Template />} />
          <Route path="fillers" element={<Fillers />} />
          {/* Add actual component routes using shared components */}
          <Route path="status" element={<Status />} />
          <Route path="upload-card" element={<UploadCard />} />
          <Route path="card-data" element={<CardData />} />
          <Route path="profile" element={<Profile />} />
          <Route path="subscription" element={<Subscription />} />
        </Route>
      </Route>

      {/* Admin Protected Routes */}
      <Route element={<AdminProtectedRoute />}>
        <Route 
          path="/admin" 
          element={
            <AdminLayout
              successOpen={successOpen}
              setsuccessOpen={setsuccessOpen}
              successMessage={successMessage}
              setsuccessMessage={setsuccessMessage}
              successStatus={successStatus}
              setsuccessStatus={setsuccessStatus}
              successColor={successColor}
              setsuccessColor={setsuccessColor}
            />
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="template" element={<TemplateTable />} />
          <Route path="create-template" element={<Template />} />
          <Route path="fillers" element={<Fillers />} />
          <Route path="status" element={<Status />} />
          <Route path="upload-card" element={<UploadCard />} />
          <Route path="card-data" element={<CardData />} />
          <Route path="profile" element={<Profile />} />
          <Route path="subscription" element={<Subscription />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="payments" element={<AdminPayments />} />
          <Route path="plans" element={<AdminPlans />} />
          <Route path="logs" element={<AdminLogs />} />
        </Route>
      </Route>

      {/* Catch-all redirect */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default App;
